module.exports = __webpack_public_path__ + "static/media/loading.6b76b046.svg";